import React from "react";
import { Box, Typography } from "@mui/material";

const PLACEHOLDER_IMAGES = Array(6).fill(
  "/assets/images/placeholder_img.png"
);

export default function MaterialPhotos({
  vendorImages = [],
  // materialImages = [],
}) {
  const images =
    vendorImages.length 
    // || materialImages.length
      ? [...vendorImages, 
        // ...materialImages
      ]
      : PLACEHOLDER_IMAGES;

  return (
    <Box>
      <Box mb={3}>
        <Typography fontSize={18} fontWeight={600}>
          Company Photos
        </Typography>
        <Typography fontSize={13} color="text.secondary">
          A glimpse of our materials, warehouse and operations
        </Typography>
      </Box>

      <Box
        sx={{
          display: "grid",
          gridTemplateColumns: {
             xs: "1fr",
            sm: "repeat(3, 1fr)",
            md: "repeat(4, 1fr)",
          },
          gap: 2,
        }}
      >
        {images.map((img, index) => (
          <Box
            key={index}
            sx={{
              overflow: "hidden",
              borderRadius: 2,
              border: "1px solid #e0e0e0",
              height: 180,
              "& img": {
                transition: "transform 0.35s ease",
              },
              "&:hover img": {
                transform: "scale(1.05)",
              },
            }}
          >
            <img
              src={img}
              alt={`material-${index}`}
              onError={(e) =>
                (e.target.src =
                  "/assets/images/placeholder_img.png")
              }
              style={{
                width: "100%",
                height: "100%",
                objectFit: "cover",
                display: "block",
              }}
            />
          </Box>
        ))}
      </Box>
    </Box>
  );
}
